<template>
	<div class="ui-dialog" v-show="data.data.length">
		<transition v-for="(item, i) in data.data" :key="item.id" :name="item.transition">
			<component :is="item.component" v-bind="item.props" @close="item.close($event)"></component>
		</transition>
	</div>
</template>

<script>
import Dialog from "../store/Dialog";
export default {
	name: "dialog",
	props: {
		data: {type: Dialog, required: true},
	},
};
</script>
<style lang="less">
.ui-dialog {
	position: fixed;
	z-index: 1000;
}
</style>
